<template>
  <div class="spinner">
    <div class="loader" id="loader"></div>
    <span class="loadingDescription" style="margin-left: 1rem;">{{ text }}</span>
  </div>
</template>

<script setup>
defineProps({
  text: {
    type: String,
    default: ''
  }
})
</script>

<style scoped>
.spinner {
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  backdrop-filter: blur(5px);
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(255,255,255,0.7);
  z-index: 9999;
  font-size: 1.5rem;
}
</style>